// extracted by mini-css-extract-plugin
export default {"StrollerDetailRating":"xh_a bhc_a bhc_x","StrollerDetailRating__muted":"xh_b bhc_fi"};